import React, { useEffect, useRef, useState } from 'react';
import Header from './common-components/Header/Header';
import HeroSlider from './common-components/Hero/HeroSlider';
import Footer from './common-components/Footer/Footer';
import BackToTop from './common-components/Back-to-top/BackToTop';
import CategoryBanner from './common-components/Category-Banner/CategoryBanner';
import HomeShop from './common-components/Home-Shop/HomeShop';
import ParallaxBanner from './common-components/Parallax-Banner/Parallaxbanner';
import BrandSection from './common-components/Brand-Section/BrandSection';
import FeaturedProductsShop from './common-components/Featured-Products-Shop/FeaturedProductsShop';
import ParallaxBannerLower from './common-components/Parallax-Banner/ParallaxBannerLower';
import DualCategoryShowcase from './common-components/Dualcategoryshowcase/Dualcategoryshowcase';
import EditorialGrid from './common-components/Editorialgrid/Editorialgrid';
import HeritageBanner from './common-components/Heritagebanner/Heritagebanner';
import HeaderSpacer from './common-components/Header/HeaderSpacer';
import CustomerReviews from './common-components/Customer-Review/CustomerReviews';
import BannerPopup from './common-components/Banner-Popup/BannerPopup';

// ─── Animation Styles ────────────────────────────────────────────────────────
const animationStyles = `
  /* ── Reveal Animations ── */
  .reveal {
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.75s cubic-bezier(0.16, 1, 0.3, 1),
                transform 0.75s cubic-bezier(0.16, 1, 0.3, 1);
  }
  .reveal.reveal--visible {
    opacity: 1;
    transform: translateY(0);
  }

  .reveal-left {
    opacity: 0;
    transform: translateX(-50px);
    transition: opacity 0.8s cubic-bezier(0.16, 1, 0.3, 1),
                transform 0.8s cubic-bezier(0.16, 1, 0.3, 1);
  }
  .reveal-left.reveal--visible {
    opacity: 1;
    transform: translateX(0);
  }

  .reveal-right {
    opacity: 0;
    transform: translateX(50px);
    transition: opacity 0.8s cubic-bezier(0.16, 1, 0.3, 1),
                transform 0.8s cubic-bezier(0.16, 1, 0.3, 1);
  }
  .reveal-right.reveal--visible {
    opacity: 1;
    transform: translateX(0);
  }

  .reveal-scale {
    opacity: 0;
    transform: scale(0.92);
    transition: opacity 0.7s cubic-bezier(0.16, 1, 0.3, 1),
                transform 0.7s cubic-bezier(0.16, 1, 0.3, 1);
  }
  .reveal-scale.reveal--visible {
    opacity: 1;
    transform: scale(1);
  }

  /* ── Stagger delays for children ── */
  .stagger-children > *:nth-child(1) { transition-delay: 0ms; }
  .stagger-children > *:nth-child(2) { transition-delay: 100ms; }
  .stagger-children > *:nth-child(3) { transition-delay: 200ms; }
  .stagger-children > *:nth-child(4) { transition-delay: 300ms; }
  .stagger-children > *:nth-child(5) { transition-delay: 400ms; }
  .stagger-children > *:nth-child(6) { transition-delay: 500ms; }

  /* ── Section heading animated underline ── */
  .section-heading {
    position: relative;
    display: inline-block;
  }
  .section-heading::after {
    content: '';
    position: absolute;
    bottom: -6px;
    left: 0;
    width: 0;
    height: 2px;
    background: currentColor;
    transition: width 0.6s cubic-bezier(0.16, 1, 0.3, 1) 0.4s;
  }
  .reveal--visible .section-heading::after,
  .section-heading.reveal--visible::after {
    width: 100%;
  }

  /* ── Divider line animation ── */
  .animated-divider {
    width: 0;
    height: 1px;
    background: linear-gradient(90deg, transparent, #717fe0, transparent);
    margin: 0 auto;
    transition: width 1.2s cubic-bezier(0.16, 1, 0.3, 1) 0.2s;
  }
  .reveal--visible .animated-divider {
    width: 80%;
  }

  /* ── Section wrapper hover lift ── */
  .section-card {
    transition: box-shadow 0.4s ease, transform 0.4s ease;
    border-radius: 2px;
  }

  /* ── Floating label effect on section headings ── */
  .section-label {
    font-size: 11px;
    letter-spacing: 0.25em;
    text-transform: uppercase;
    color: #717fe0;
    opacity: 0;
    transform: translateY(10px);
    transition: opacity 0.5s ease 0.2s, transform 0.5s ease 0.2s;
  }
  .reveal--visible .section-label,
  .section-block.reveal--visible .section-label {
    opacity: 1;
    transform: translateY(0);
  }

  /* ── Pulse badge for "NEW" or sale items ── */
  @keyframes pulse-ring {
    0%   { transform: scale(0.8); opacity: 0.6; }
    100% { transform: scale(1.4); opacity: 0; }
  }

  /* ── Smooth section separator ── */
  .section-separator {
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 10px 0 30px;
    opacity: 0;
    transition: opacity 0.6s ease 0.3s;
  }
  .section-separator .sep-line {
    flex: 1;
    height: 1px;
    background: linear-gradient(90deg, transparent, #d5d9f5);
  }
  .section-separator .sep-line:last-child {
    background: linear-gradient(270deg, transparent, #d5d9f5);
  }
  .section-separator .sep-diamond {
    width: 6px;
    height: 6px;
    background: #717fe0;
    transform: rotate(45deg);
    flex-shrink: 0;
  }
  .reveal--visible .section-separator,
  .section-block.reveal--visible .section-separator {
    opacity: 1;
  }

  /* ── Page load hero fade ── */
  @keyframes heroFadeIn {
    from { opacity: 0; transform: scale(1.02); }
    to   { opacity: 1; transform: scale(1); }
  }
  .hero-wrapper {
    animation: heroFadeIn 1.2s cubic-bezier(0.16, 1, 0.3, 1) forwards;
    width: 100%;
  }

  /* ── Smooth scroll behavior ── */
  html {
    scroll-behavior: smooth;
  }

  /* ── Section entrance — NO overflow hidden (causes animation clipping) ── */
  .section-block {
    position: relative;
  }
  .section-block::before {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(180deg, rgba(255,255,255,0.03) 0%, transparent 100%);
    pointer-events: none;
    z-index: 0;
  }
  .section-block > * {
    position: relative;
    z-index: 1;
  }

  /* ── Marquee ticker ── */
  @keyframes marquee {
    from { transform: translateX(0); }
    to   { transform: translateX(-50%); }
  }
  .marquee-track {
    display: flex;
    animation: marquee 28s linear infinite;
    white-space: nowrap;
  }
  .marquee-track:hover {
    animation-play-state: paused;
  }
  .marquee-wrapper {
    overflow: hidden;
    border-top: 1px solid #e6e6e6;
    border-bottom: 1px solid #e6e6e6;
    padding: 14px 0;
    background: #f8f8fc;
    /* CRITICAL: must be visible above everything except the fixed header */
    position: relative;
    z-index: 1;
    width: 100%;
  }
  .marquee-item {
    display: inline-flex;
    align-items: center;
    gap: 28px;
    padding-right: 56px;
    font-size: 12px;
    letter-spacing: 0.18em;
    text-transform: uppercase;
    color: #888;
    font-weight: 500;
  }
  .marquee-dot {
    width: 4px;
    height: 4px;
    background: #717fe0;
    border-radius: 50%;
    flex-shrink: 0;
  }

  /* ────────────────────────────────────────────────────────────────────────────
     MOBILE FIXES
  ──────────────────────────────────────────────────────────────────────────── */
  @media (max-width: 768px) {
    .reveal,
    .reveal-left,
    .reveal-right,
    .reveal-scale,
    .section-block {
      opacity: 1 !important;
      transform: none !important;
      transition: none !important;
    }
    .section-label {
      opacity: 1 !important;
      transform: none !important;
      transition: none !important;
    }
    .section-separator {
      opacity: 1 !important;
      transition: none !important;
    }
    .section-block::before {
      display: none;
    }
    section.bg0 {
      padding-top: 40px !important;
    }
  }

  @media (max-width: 576px) {
    .container {
      padding-left: 12px !important;
      padding-right: 12px !important;
      width: 100% !important;
      max-width: 100% !important;
    }
    .hero-wrapper {
      width: 100vw !important;
      margin-left: 0 !important;
      margin-right: 0 !important;
    }
    .marquee-wrapper {
      width: 100vw !important;
      margin-left: 0 !important;
    }
    .ltext-103 {
      font-size: 24px !important;
      line-height: 1.2 !important;
    }
  }
`;

// ─── Hook: Intersection Observer ─────────────────────────────────────────────
function useScrollReveal() {
  useEffect(() => {
    if (window.innerWidth <= 768) return;

    const els = document.querySelectorAll(
      '.reveal, .reveal-left, .reveal-right, .reveal-scale, .section-block'
    );

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('reveal--visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.05, rootMargin: '0px 0px -20px 0px' }
    );

    els.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);
}

// ─── Hook: measure only the visible nav bar height ────────────────────────────
function useHeaderHeight(): number {
  const [height, setHeight] = useState(70);

  useEffect(() => {
    const getNavHeight = (): number => {
      const desktop = document.querySelector<HTMLElement>('.container-menu-desktop');
      if (desktop && desktop.offsetParent !== null) {
        return desktop.getBoundingClientRect().height;
      }
      const mobile = document.querySelector<HTMLElement>('.wrap-header-mobile');
      if (mobile) return mobile.getBoundingClientRect().height;
      return 70;
    };

    const update = () => setHeight(getNavHeight());
    const timeout = setTimeout(update, 60);

    const ro = new ResizeObserver(update);
    const desktop = document.querySelector<HTMLElement>('.container-menu-desktop');
    const mobile = document.querySelector<HTMLElement>('.wrap-header-mobile');
    if (desktop) ro.observe(desktop);
    if (mobile) ro.observe(mobile);

    return () => {
      clearTimeout(timeout);
      ro.disconnect();
    };
  }, []);

  return height;
}

// ─── Hook: measure an element's height via a ref ─────────────────────────────
function useElementHeight(): [React.RefObject<HTMLDivElement | null>, number] {
  const ref = useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState(0);

  useEffect(() => {
    if (!ref.current) return;

    // Measure immediately
    setHeight(ref.current.getBoundingClientRect().height);

    // Re-measure on resize (e.g. font changes, window resize)
    const ro = new ResizeObserver(() => {
      setHeight(ref.current?.getBoundingClientRect().height ?? 0);
    });
    ro.observe(ref.current);
    return () => ro.disconnect();
  }, []);

  return [ref, height];
}

// ─── Marquee Ticker ───────────────────────────────────────────────────────────
const MarqueeTicker = React.forwardRef<HTMLDivElement | null>((_, ref) => {
  const items = [
    'New Season Arrivals',
    'Handcrafted Luxury Fabrics',
    'Exclusive Designer Collections',
    'Bridal & Occasion Wear',
    'Timeless Style',
    'Custom Tailored Designs',
    'Certified Sustainable Materials',
    'Fashion You Can Trust',
    'Perfect Outfits for Every Occasion',
    'Dress to Impress Every Day',
  ];

  return (
    <div className="marquee-wrapper" ref={ref}>
      <div className="marquee-track">
        {[...items, ...items].map((item, i) => (
          <span key={i} className="marquee-item">
            {item}
            <span className="marquee-dot" />
          </span>
        ))}
      </div>
    </div>
  );
});
MarqueeTicker.displayName = 'MarqueeTicker';

// ─── Section Heading ──────────────────────────────────────────────────────────
interface SectionHeadingProps {
  label?: string;
  title: string;
}
const SectionHeading: React.FC<SectionHeadingProps> = ({ label, title }) => (
  <div className="p-b-10">
    {label && <p className="section-label">{label}</p>}
    <h3 className="ltext-103 cl5 section-heading">{title}</h3>
    <div className="section-separator">
      <div className="sep-line" />
      <div className="sep-diamond" />
      <div className="sep-line" />
    </div>
  </div>
);

// ─── Home Component ───────────────────────────────────────────────────────────
const Home: React.FC = () => {
  useScrollReveal();

  const headerHeight = useHeaderHeight();

  // Measure the marquee bar so its height is subtracted from the hero's
  // calc(100vh - offset), keeping the slider perfectly viewport-fitted.
  const [marqueeRef, marqueeHeight] = useElementHeight();

  // Total offset = fixed header + marquee ticker sitting above the hero
  const heroOffset = headerHeight + marqueeHeight;

  return (
    <div style={{ width: '100%', overflowX: 'hidden' }}>
      {/* Inject animation CSS */}
      <style>{animationStyles}</style>

      {/* Fixed header — sits above everything */}
      <Header />

      {/*
        ── HEADER SPACER ──────────────────────────────────────────────────────
        Pushes page content below the fixed nav bar only (not the marquee).
      */}
      <div
        aria-hidden="true"
        style={{
          height: headerHeight,
          flexShrink: 0,
          transition: 'height 0.4s cubic-bezier(0.16, 1, 0.3, 1)',
        }}
      />

      {/* ── Marquee — measured via ref so its height feeds into heroOffset ── */}
      <MarqueeTicker ref={marqueeRef} />

      {/* ── Hero — full viewport height minus header AND marquee ── */}
      <div className="hero-wrapper">
        <HeroSlider headerHeight={heroOffset} />
      </div>

      {/* ── Featured Categories ── */}
      <section className="bg0 p-t-100 p-b-0 section-block reveal">
        <div className="container">
          <SectionHeading label="Shop By" title="Featured Categories" />
          <div className="reveal stagger-children">
            <CategoryBanner />
          </div>
        </div>
      </section>

      {/* ── Heritage Banner ── */}
      <div className="reveal-scale">
        <HeritageBanner />
      </div>

      {/* ── Featured Products ── */}
      <section className="bg0 p-t-100 p-b-50 section-block reveal">
        <div className="container">
          <SectionHeading label="Hand-Picked" title="Featured Products" />
          <div className="reveal">
            <FeaturedProductsShop />
          </div>
        </div>
      </section>

      {/* ── Parallax Banner ── */}
      <div className="reveal-scale">
        <ParallaxBanner />
      </div>

      {/* ── Editorial Grid ── */}
      <div className="reveal">
        <EditorialGrid />
      </div>

      {/* ── Featured Brands ── */}
      <section className="bg0 p-t-100 p-b-0 section-block reveal">
        <div className="container">
          <SectionHeading label="Our Partners" title="Featured Brands" />
          <div className="reveal stagger-children">
            <BrandSection />
          </div>
        </div>
      </section>

      {/* ── Product Overview ── */}
      <section className="bg0 p-t-60 p-b-60 section-block reveal">
        <div className="container">
          <SectionHeading label="Explore All" title="Product Overview" />
          <div className="reveal">
            <HomeShop />
          </div>
        </div>
      </section>

      <section className="bg0 p-t-60 p-b-140 section-block reveal">
        <div className="container">
          <SectionHeading label="Golden Thoughts" title="Customer Reviews" />
          <div className="reveal">
            <CustomerReviews />
          </div>
        </div>
      </section>

      <BannerPopup />
      <Footer />
      <BackToTop />
    </div>
  );
};

export default Home;